<template>
  <label class="checkbox">
    <input
      class="input"
      type="checkbox"
      v-model="checked"
      v-bind="$attrs">
    <span class="checkbox-icon">
      <icon name="check"/>
    </span>
  </label>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      handler(value) {
        this.checked = value;
      },
      immediate: true,
    },
    checked: {
      handler(value) {
        this.$emit('input', value);
      },
    },
  },
  data() {
    return {
      checked: false,
    };
  },
};
</script>

<style lang="scss" scoped>
  .checkbox {
    margin: 0;

    .input {
      opacity: 0;
      position: fixed;
      top: -100px;
      left: -100px;
      z-index: -5;

      &:focus {
        & + .checkbox-icon {
          border: 1px solid rgba(white, .6);
        }
      }

      &:checked {
        & + .checkbox-icon {
          background: black;

          .icon {
            display: inline-block;
          }
        }
      }
    }

    &-icon {
      display: block;
      width: 20px;
      height: 20px;
      border-radius: 3px;
      background: #3D3D3D;
      border: 1px solid #626262;
      line-height: 50%;
      text-align: center;
      position: relative;

      .icon {
        display: none;
        left: 20%;
        width: 60%;
        height: 100%;
        position: absolute;
      }
    }
  }
</style>
